// generated from 36 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const treasureDataCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("treasure_data_cohort_filter"),
  comparison_key: z.enum([
    "7", // 18 (50.00%)
    "8", // 18 (50.00%)
  ]),
  display_name: z.string(),
  value: z.object({
    id: z.string(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
